module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kf-Ld.30cdb69c.png";